import React, { useState } from 'react';
import { useContext } from 'react';
import ProductBanner from '@/globalComponents/productBanner';
import { ProductContext } from '@/context/productContext';
import { DeviceSelectionModal } from './deviceSelectionModal';
import { Button } from '@/globalComponents/button';
import style from './style.module.scss';
import { ProductDetails } from '../ProductDetails';
import { WebEngageContext } from '@/context/webengageContext';
import { AppScreens, WebEngageCommonEventData, WebEngageEventNames } from '@/types/wegengage';
import WebEngageUtils from '@/utils/webengageUtils';
import AppBar from '@/shared/AppBar';
import { useRouter } from 'next/router';

const DeviceContainer = (props: any) => {
  const {
    productsData,
    isServiceFlow = false,
    isServicePage = false,
    newDeviceCard,
    isOpenServiceRequest,
    savingPromotionData = {},
    showBookServiceCta,
  } = props;

  const { state: productState, dispatch: productAction } = useContext(ProductContext);
  const [openDeviceModal, setDeviceModal] = useState<boolean>(false);
  const { state: webengageState } = useContext(WebEngageContext);
  const router = useRouter();
  const trackwebengageEvent = () => {
    const _we = window.webengage;
    if (_we) {
      const eventData: WebEngageCommonEventData = {
        ...webengageState.webengageDefault,
        navigated_from: AppScreens.AMC_TIER_SELECTION_SCREEN,
        customer_type: WebEngageUtils.stringUtil(
          productState.selectedProduct?.expiryStatus?.status,
        ),
        customer_code: WebEngageUtils.stringUtil(productState.selectedProduct?.customerCode),
      };
      _we.track(WebEngageEventNames.PRODUCT_SELECTION_POPUP_OPENED, eventData);
    }
  };

  const renderProductDetails = () => {
    const selectedProduct = productState.selectedProduct ?? productsData[0];
    return <ProductDetails {...selectedProduct} />;
  };

  const handleBackClick = () => {
    router.back();
  };

  return (
    <>
      {isServiceFlow ? (
        <>
          <AppBar transparent className="!p-0" onClick={handleBackClick} />
          <div className="flex items-center justify-between">
            <h2
              className={`md:font-bold md:text-lg md:leading-[1.875rem] font-semibold text-base leading-[1.125rem] ${style.yourDeviceText}`}
            >
              Your Device
            </h2>
          </div>
          {renderProductDetails()}
        </>
      ) : (
        <ProductBanner
          onClick={() => {
            trackwebengageEvent();
            productAction.setDisablePageScroll(true);
            setDeviceModal(true);
          }}
          savingPromotionData={savingPromotionData}
          isOpenServiceRequest={isOpenServiceRequest}
          newDeviceCard={newDeviceCard}
          deviceDetails={productState?.selectedProduct || productsData[0]}
          isMultipleDevices={productsData?.length > 1}
          productTitleClasses="w-[85%] font-bold text-[0.875rem] md:text-[1.375rem] leading-[1.125rem] md:leading-[1.875rem] mt-1 md:mt-2"
          badgeClasses="font-extrabold text-[0.5625rem] md:text-xs leading-[0.625rem] md:leading-[0.625rem]"
          productLocationClasses="font-normal text-xs md:text-lg !leading-[0.875rem] text-[#828282]"
          cardClasses="py-4 px-2 md:pt-[1.3125rem] md:pb-[0.8125rem] md:px-8 border-[0.5px] md:border-0 border-[#4F4F4F]"
          showBookServiceCta={showBookServiceCta}
        />
      )}
    </>
  );
};

export default DeviceContainer;
